import React from 'react'

export default class Detector extends React.Component {
  state = {
    online: true,
    leftAt: null,
  }

  componentDidMount() {
    window.addEventListener('online', this.onChangeConnection.bind(this))
    window.addEventListener('offline', this.onChangeConnection.bind(this))

    window.addEventListener('blur', this.onBlur.bind(this))
    window.addEventListener('focus', this.onFocus.bind(this))
  }

  onChangeConnection = event => {
    const { onChange } = this.props

    const online = event.type === 'online'

    this.setState({ online }, () => {
      onChange(online)
    })
  }

  onBlur = () => {
    this.setState({ leftAt: new Date() })
  }

  onFocus = () => {
    const { leftAt } = this.state
    const now = new Date()
    const inactivityPeriod = leftAt ? now - leftAt : 0
    const quarterHour = 1000 * 60 * 15

    if (inactivityPeriod > quarterHour) {
      window.location.reload()
    } else {
      this.setState({ leftAt: null })
    }
  }

  render() {
    const { online } = this.state
    const { render } = this.props

    return render({ online })
  }
}



// WEBPACK FOOTER //
// ./src/components/common/Detector.js